import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { css } from '@emotion/react';
import { LinkIcon } from '../../../elements';
import Block from '../../block';
import ElementGroup from '../../element-group';
import { SmartLinkAlignment, SmartLinkDirection, SmartLinkPosition, SmartLinkWidth } from '../../../../../../constants';
import { renderElementItems } from '../../utils';

/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */
const TitleBlockResolvedView = ({
  actionGroup,
  metadata = [],
  position,
  subtitle = [],
  testId,
  text,
  icon,
  title,
  metadataPosition,
  hideIcon,
  ...blockProps
}) => {
  const metadataElements = renderElementItems(metadata);
  const subtitleElements = renderElementItems(subtitle);
  return /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
    testId: `${testId}-resolved-view`
  }), !hideIcon && /*#__PURE__*/React.createElement(LinkIcon, {
    overrideIcon: icon,
    position: position
  }), /*#__PURE__*/React.createElement(ElementGroup, {
    direction: SmartLinkDirection.Vertical,
    width: SmartLinkWidth.Flexible,
    overrideCss: css({
      gap: "var(--ds-space-050, 0.25rem)"
    })
  }, title, subtitleElements && /*#__PURE__*/React.createElement(ElementGroup, {
    direction: SmartLinkDirection.Horizontal
  }, subtitleElements)), metadataElements && /*#__PURE__*/React.createElement(ElementGroup, {
    direction: SmartLinkDirection.Horizontal,
    align: SmartLinkAlignment.Right,
    position: metadataPosition !== null && metadataPosition !== void 0 ? metadataPosition : SmartLinkPosition.Center
  }, metadataElements), actionGroup);
};
export default TitleBlockResolvedView;